export default "/packs/images/mike-and-yeti~911dea269fb6c5c4b8bdd7c05a4e0efa.png";